import { fetchAllPayouts, fetchPayoutsById } from "@services/api/payouts/payoutServices";
import { useQuery } from '@tanstack/react-query';
import { PayoutContentById, PayoutResponse } from "types/payouts/payoutTypes";


export const useAllPayouts=()=>{
    const {data,isLoading,error,refetch}=useQuery<PayoutResponse,Error>({
            queryKey:['payouts'],
            queryFn:()=>fetchAllPayouts(),
            refetchOnWindowFocus: false
    });
    return{
        data,
        isLoading,
        error,
        refetch
    }
}

export const usePayoutsById=(id:string)=>{
    const {data,isLoading,error}=useQuery<PayoutContentById,Error>({
            queryKey:['payouts',id],
            queryFn:()=>fetchPayoutsById(id),
            refetchOnWindowFocus: false
    });
    return{
        data,
        isLoading,
        error
    }
}